import { render } from "./danbi-ticheng.vue?vue&type=template&id=e9e2e9dc&scoped=true"
import script from "./danbi-ticheng.vue?vue&type=script&lang=js"
export * from "./danbi-ticheng.vue?vue&type=script&lang=js"

import "./danbi-ticheng.vue?vue&type=style&index=0&id=e9e2e9dc&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9e2e9dc"]])

export default __exports__